<template>
<router-view></router-view>
</template>

<script>
export default {
  name: "index"
}
</script>

<style lang="scss">
.paydetail .subtitle {
  font-size: 16px;
  font-weight: 600;
  color: #5E5873;
  margin-bottom: 16px;
}
</style>
